/** Normalize PDF URL path (e.g. strip accidental spaces in `/invoice /file.pdf`). */
export function normalizeQuotationPdfUrl(raw: string): string {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return trimmed;
  try {
    const u = new URL(trimmed);
    u.pathname = u.pathname.replace(/\s+/g, '');
    return u.href;
  } catch {
    return trimmed.replace(/\/\s+/g, '/').replace(/\s+\//g, '/');
  }
}

/** Trigger a file download for a quotation PDF URL. */
export async function downloadQuotationPdfFile(
  rawUrl: string,
  fallbackName = 'quotation.pdf',
): Promise<void> {
  const url = normalizeQuotationPdfUrl(rawUrl);
  const fileName = decodeURIComponent(url.split('/').pop() || fallbackName);

  try {
    const response = await fetch(url, { credentials: 'include' });
    if (!response.ok) throw new Error('fetch failed');
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
    return;
  } catch {
    /* Cross-origin or CORS: rely on server Content-Disposition: attachment */
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
